import { render, staticRenderFns } from "./SupplyList.vue?vue&type=template&id=179b3e7f&scoped=true&"
import script from "./SupplyList.vue?vue&type=script&lang=js&"
export * from "./SupplyList.vue?vue&type=script&lang=js&"
import style0 from "./SupplyList.vue?vue&type=style&index=0&id=179b3e7f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "179b3e7f",
  null
  
)

export default component.exports